import { useContext, useEffect, useState } from "react";

import type { CheckboxProps } from "antd";
import { DirectoriesFormProps } from "./types";
import Form from "antd/lib/form";
import { FormContext } from "../../../contexts/form/index.context";
import FormItems from "./utils/form-items";
import { ModalContext } from "../../../contexts/modal/index.context";
import { SessionContext } from "../../../contexts/session/index.context";
import { TranslationContext } from "../../../contexts/translation/index.context";
import message from "antd/lib/message";
import { request } from "../../../services";
import { setFieldValuesFunctions } from "./utils/set-field-values";
import styles from "./styles.module.scss";
import { translateDictionary } from "../../../translation";
import { useLocation } from "react-router-dom";

//Utils

//UI

// Компонент Форма всередині модалки

export default function DirectoriesForm(props: DirectoriesFormProps) {
  
  const location = useLocation();
  const { form } = useContext(FormContext);
  const { intl } = useContext(TranslationContext);
  const { sessionData, setSessionData, tableState, setTableState } = useContext(SessionContext);
  const [checkboxes, setCheckboxes] = useState<string[]>([]);
  const { activeModal, disabled, setDisabled, setRefresh } = useContext(ModalContext);

  useEffect(() => {
    // console.log("DirectoriesForm VALUES  : ", form);

    if (activeModal === "edit" && sessionData) {
      const setFieldValues =
        setFieldValuesFunctions[props.url || location.pathname];
      setFieldValues && setFieldValues(form, sessionData);
    } else {
      form.resetFields();
    }
  }, [activeModal, sessionData]);

  const onChange: CheckboxProps["onChange"] = (e) => {
    if (e.target.checked) {
      setCheckboxes([...checkboxes, e.target.value]);
    } else {
      setCheckboxes(checkboxes.filter((item) => item !== e.target.value));
    }
  };

  const getURL = (
    baseURL: string,
    activeModal: string | null,
    sessionData: any
  ) => {
    if (baseURL !== "/directories/employees-and-contact-persons") {
      return baseURL;
    }
    if (activeModal === "edit") {
      return `${baseURL}/${
        sessionData.is_clerk ? "employee" : "contact-person"
      }`;
    }
    return `${baseURL}/${activeModal}`;
  };

  const info = (text: string) => {
    message.info(intl(text));
  };

  const onFinish = async (values: any) => {
    // console.log("onFinish DirectoriesForm :", values);
    // if(values){
    //   console.log("Final values before submit:", values);
    //   return;
    // }
  try {
    let response;
    let url = getURL(
      `${props.url || location.pathname}`,
      activeModal,
      sessionData
    );
    console.log(checkboxes, "checkboxes 1");
    values.checkboxes = checkboxes.join(",");
    url === "/profile/menu-tabs" &&
      (values.translate = translateDictionary(values.nameFolder));

    if (activeModal === "edit") {
      values.id = sessionData.id;
    }
    // console.log(values, "onFinish");
    // console.log(sessionData, "onFinish sessionData");
    const endpoint =
      activeModal === "edit" ? "updatedatatable" : "adddatatable";
    // console.log(`${url}/${endpoint}`, "onFinish ${url}/${endpoint}");
    response = await request(`${url}/${endpoint}`, {
      method: "post",
      body: {
        documentId: props.id ?? sessionData?.bta_documents_id,
        page: props.url?.split("/").pop(),
        ...values,
      },
      cancelTokenKey: endpoint,
    });
    activeModal !== "edit" && setDisabled({ ...disabled, edit: false });

    url === "/profile/menu-tabs" &&
      info(
        !response.success
          ? "menu-tab-with-this-name-already-exists"
          : "changes-will-take-effect-only-after-the-user-re-authorizes-the-system"
      );
    if (response.success) {
      setSessionData(response.data[0] ?? {} );
      setTableState({ 
        ...tableState,
        selectedRow: response.data[0].id
      });
      // console.log("Success VALUE DirectoriesForm :", response);
    }
    if (response.success) {
      // console.log("Success VALUE 2 DirectoriesForm:", response);
      props?.setIsShowModal && props.setIsShowModal(false);
      form.resetFields();
      setRefresh(true);
      props.onSubmitDone?.(!!response.success);
    } else {
      props.onSubmitDone?.(false);

    }
  } catch (error) {
      props.onSubmitDone?.(false);
  }
  };

  const onFinishFailed = (errorInfo: any) => {
    props.onSubmitDone?.(false);
    console.log("Failed directories:", errorInfo);
  };

  return (
    <Form
      className={styles["form"]}
      name="directories"
      layout="vertical"
      form={form}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      initialValues={{ webVersion: true }}
    >
      <FormItems
        pathname={props.url || location.pathname}
        onChange={onChange}
      />
    </Form>
  );
}
